export class ProfileSheetInvoiceModalCookie {
  private static readonly cookieName = 'profile_sheet_invoice_modal_open'

  static store = () => {
    document.cookie = `${this.cookieName}=true;path=/;max-age=60`
  }

  static clear = () => {
    document.cookie = `${this.cookieName}=true;path=/;max-age=0`
  }
}
